import { render, staticRenderFns } from "./SimpleSnackbar.vue?vue&type=template&id=4c62fabe&scoped=true&"
import script from "./SimpleSnackbar.vue?vue&type=script&lang=js&"
export * from "./SimpleSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSnackbar.vue?vue&type=style&index=0&id=4c62fabe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c62fabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
